<template>
    <div>
        <div class="flex flex-col h-full w-full min-w-full">
            <label
                v-if="label"
                for="keywords-input"
                class="block text-sm text-theme-muted mb-1 font-semibold"
                >{{ label }}</label
            >

            <div id="keywords-input" class="flex flex-wrap px-2 items-center">
                <div
                    v-for="(item, index) in keywords"
                    :key="index"
                    class="bg-brand-blue text-white rounded-lg mx-1 px-1 flex items-center mt-1"
                    :label="item"
                    :value="item"
                >
                    <small>{{ item }}</small>
                    <button
                        v-if="enabled"
                        class="bg-brand-purple text-white rounded-lg ml-1 p-1"
                        @click="deleteKeyword(index)"
                    >
                        <small> ❌ </small>
                    </button>
                </div>
                <div v-if="keywords.length === 0">Sin {{ label }}</div>
                <div v-if="enabled">
                    <custom-tooltip border>
                        <template #tooltip> Agregar palabras </template>
                        <button
                            class="btn bg-theme-success cursor-pointer rounded-lg mx-1 px-1 mt-1"
                            @click="isOpenInput = true"
                        >
                            <small>➕</small>
                        </button>
                    </custom-tooltip>
                </div>
            </div>
        </div>
        <app-dialog v-model="isOpenInput">
            <div>
                <div
                    v-if="description"
                    class="bg-theme-canvas border border-theme-border rounded-lg p-3 mb-4 max-w-md"
                >
                    <p class="text-sm text-theme-muted">{{ description }}</p>
                </div>
                <div class="flex items-end gap-3 mt-5">
                    <custom-input
                        v-model="keyword"
                        class="w-full"
                        :label="`Nueva ${label} (Separa por ',')`"
                        @enter="addNewKeyword"
                    />
                    <app-button icon border @click="addNewKeyword">
                        ✔️
                    </app-button>
                </div>
            </div>
        </app-dialog>
    </div>
</template>

<script>
import AppDialog from "@/components/utils/AppDialog.vue";
import CustomInput from "@/components/utils/CustomInput.vue";

export default {
    name: "KeywordsManage",
    components: { AppDialog, CustomInput },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        label: {
            type: String,
            default: () => "",
            required: false
        },
        description: {
            type: String,
            default: () => "",
            required: false
        },
        enabled: {
            default: () => false,
            type: Boolean,
            required: false
        },
        itemsCurrent: {
            type: Array,
            default: () => [],
            required: true
        }
    },
    emits: ["change"],
    data: () => ({
        keywords: [],
        isOpenInput: false,
        keyword: ""
    }),
    watch: {
        itemsCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemsCurrent);
    },
    methods: {
        setInput(value) {
            this.keywords = [...value].filter(
                (value, index, self) =>
                    self.findIndex((item) => item === value) === index
            );
        },
        deleteKeyword(index) {
            this.keywords.splice(index, 1);
        },
        addNewKeyword() {
            if (this.keyword) {
                const value = [
                    ...this.keyword.split(", "),
                    ...this.keywords
                ].filter(
                    (value, index, self) =>
                        self.findIndex((item) => item === value) === index
                );
                this.keywords = value;
                this.keyword = "";
                this.onInput();
            }
            this.isOpenInput = false;
        },
        onInput() {
            this.$emit("change", this.keywords);
        }
    }
};
</script>
